<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-page-header @back="onBack" title="" content="編輯分校">
        </el-page-header>
      </el-col>
    </el-row>
    <div class="page-box">
      <courseUsageAnalysisReportFrom
        ref="ruleForm"
        :formLabelAlign="formLabelAlign"
      ></courseUsageAnalysisReportFrom>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBranchSchoolsDetail,
  editBranchSchools,
} from "@/api/setting";
import courseUsageAnalysisReportFrom from "./components/courseUsageAnalysisReportFrom.vue";
export default {
  components: { courseUsageAnalysisReportFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formLabelAlign: {
        abbreviation: null,
      },
    };
  },
  created() {
    this.getBranchSchoolsDetail();
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.editBranchSchools();
        }
      });
    },
    editBranchSchools() {
      editBranchSchools(this.id, this.formLabelAlign).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.$router.push({
          path: "/setting/courseUsageAnalysisReport",
        });
      });
    },
    getBranchSchoolsDetail() {
      getBranchSchoolsDetail(this.id).then((v) => {
        this.formLabelAlign = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>